let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dJhw2")).then(() => parcelRequire('1Z04w'));